import React, { Component } from "react";
import { ToggleControl } from '@wordpress/components';


class AllowSingle extends Component {

    constructor(props) {
        super(props);
    }



    render() {

        const { attributes: {allowSingle}, setAttributes } = this.props;

        const changeFunction = (value) => {
            setAttributes({
                allowSingle: value
            });
        }

        return (
            <div className="components-base-control">
                <div className="components-base-control__field">
                    <label className="components-base-control__label">Allow single-product purchases only</label>
                    <ToggleControl
                        checked={ allowSingle }
                        onChange={ changeFunction }
                    />
                </div>
            </div>
        );

    }
}


export default AllowSingle;